// src/utils/strings.js
// Safe string coercion for logging / chat bubbles
export const asString = v => {
    if (typeof v === 'string') return v;
    if (v == null) return '';                     // null / undefined → ''
  
    // Try JSON.stringify with a circular‑ref guard
    try {
      return JSON.stringify(v, getCircularReplacer(), 2);
    } catch {
      // Fallback: plain String() — last‑ditch, never throws
      return String(v);
    }
  };
  
  /**
   * Replacer that turns circular references into the string "[Circular]".
   * Adapted from MDN example.
   */
  function getCircularReplacer() {
    const seen = new WeakSet();
    return (_, value) => {
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) return '[Circular]';
        seen.add(value);
      }
      return value;
    };
  }
  